import React, { useState } from 'react';
import { Button, Card, Typography, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckOutlined, UserOutlined, ExportOutlined } from '@ant-design/icons';
import updatePatient from '../../utils/patient/updatePatient';
import { toast } from 'react-hot-toast';
import { logEvent } from '../../analytics';
import LinkButton from '../buttons/LinkButton';

const { Paragraph } = Typography;

const NoteUpdatePatient = ({ patient, patientUpdates, onUpdate }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  if (!patient || !patientUpdates) return null;

  const handleUpdate = async () => {
    try {
      setLoading(true);
      logEvent('NotePatientWidget', 'UpdatePatient');
      // Transform the updates to only include the values
      const attributes = Object.entries(patientUpdates).reduce((acc, [key, { value }]) => {
        acc[key] = value;
        return acc;
      }, {});
      
      await updatePatient(patient.getUUID(), attributes);
      toast.success(t('common.saved'));
      onUpdate();
    } catch (error) {
      toast.error(t('patient_form.errors.update_failed'));
    } finally {
      setLoading(false);
    }
  };

  const cardTitle = (
    <>
      <UserOutlined style={{ marginRight: 8 }} />
      {patient.getFullName()}
    </>
  );

  const cardExtra = (
    <LinkButton
      onClick={() => {
        logEvent('SessionDetails', 'ViewPatientProfile');
        window.open(`/patients/${patient.getUUID()}`, '_blank', 'noopener,noreferrer');
      }}
      buttonProps={{
        icon: <ExportOutlined />,
        'data-testid': 'view-profile-button'
      }}
    >
      {t('session_details_patient.view_profile')}
    </LinkButton>
  );

  return (
    <Card
      title={cardTitle}
      extra={cardExtra}
      style={{ marginBottom: 24 }}
    >
      <Paragraph style={{ fontSize: '15px' }}>{t('session_details_patient.update_patient_subtitle')}</Paragraph>
      <Descriptions column={1} size="small">
        {Object.entries(patientUpdates).map(([key, { value, label }]) => (
          <Descriptions.Item key={key} label={label}>
            <span style={{
              backgroundColor: '#fffbe6',
              padding: '0 4px',
              borderRadius: '2px',
              display: 'inline-flex',
              alignItems: 'center',
              lineHeight: '22px'
            }}>
              {value}
            </span>
          </Descriptions.Item>
        ))}
      </Descriptions>
      <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
        <Button 
          type="primary" 
          onClick={handleUpdate} 
          icon={<CheckOutlined />}
          loading={loading}
        >
          {t('session_details_patient.update_patient')}
        </Button>
      </div>
    </Card>
  );
};

export default NoteUpdatePatient; 